// 判断图片 宽高对比值
export function checkImage(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onerror = function (err) {
            reject(err);
        };
        let LoadWidth;
        let LoadHeight;
        img.onload = function () {
            LoadWidth = img.width;
            LoadHeight = img.height;
            if (LoadWidth >= LoadHeight) {
                resolve(false);
            } else {
                resolve(true);
            }
        }
    });
}